//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;


const townsend = require(`./routes/townsend.js`);
const hood = require(`./routes/hood.js`);
const skagit = require(`./routes/skagit.js`);
const cascades = require(`./routes/cascades.js`);
const leavenworth = require(`./routes/leavenworth.js`);
const sbeach = require(`./routes/sbeach.js`);
const methow = require(`./routes/methow.js`);
const hway12 = require(`./routes/hway12.js`);
const olympic = require(`./routes/olympic.js`);
const astoria = require(`./routes/astoria.js`);
const oregon = require(`./routes/oregon.js`);
const nezperce = require(`./routes/nezperce.js`);

const routes = {
  "townsend": townsend,
  "hood": hood,
  "skagit": skagit,
  "cascades": cascades,
  "leavenworth": leavenworth,
  "sbeach": sbeach,
  "methow": methow,
  "hway12": hway12,
  "olympic": olympic,
  "astoria": astoria,
  "oregon": oregon,
  "nezperce": nezperce
}

// const routes = {
//   "townsend": "./assets/routes/townsend.js",
//   "hood": "./assets/routes/hood.js",
//   "skagit": "./assets/routes/skagit.js",
//   "cascades": "./assets/routes/cascades.js",
//   "leavenworth": "./assets/routes/leavenworth.js",
//   "sbeach": "./assets/routes/sbeach.js",
//   "methow": "./assets/routes/methow.js",
//   "hway12": "./assets/routes/hway12.js",
//   "olympic": "./assets/routes/olympic.js",
//   "astoria": "./assets/routes/astoria.js",
//   "oregon": "./assets/routes/oregon.js"
// }

// console.log("./assets/routes/skagit.js");

//ICH code for popup template if needed----------
// var ich = require("icanhaz");
// var templateFile = require("./_popup.html");
// ich.addTemplate("popup", templateFile);

// var onEachFeature = function(feature, layer) {
//   layer.bindPopup(ich.popup(feature.properties))
// };

var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

var body = document.body,
    html = document.documentElement;

var docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );




const maxTrip = 1200;




var markers = [];
var markergroup = L.featureGroup()

window.course.forEach(function(data) {

  let dotColor = "Cat200";

  var marker = L.marker([data.Lat, data.Lng], {
    icon: L.divIcon({
      className: dotColor + " " + data.id
    })
  });
  var html = `
    <b>${data.Location}</b>
  `;
  marker.bindPopup(html).on('click', clickZoom);
  markers.push(marker);
  marker.addTo(markergroup);

  var chosenPath = data.path;


  // var path = require(`./routes/${data.path}.js`);
  L.polyline(routes[chosenPath], {color: 'black', className: `line Line${data.id}`}).addTo(map);
});

markergroup.addTo(map);




//add seattle
var homeMarker = L.marker([47.609682, -122.338909], {
  icon: L.divIcon({
    className: "seattle"
  })
});

homeMarker.addTo(map);

 // map.scrollWheelZoom.disable();
 // map.dragging.disable();
 map.fitBounds(markergroup.getBounds());

 function clickZoom(e) {
	map.setView(e.target.getLatLng());
}

 // map.setZoom(16);
 let nextSlide;
 let slide = 1;

 // document.getElementById("prev").style.opacity = 0.6;



var moveSlides = function() {
  var currentSlide = slide;
  console.log(currentSlide);


  if ( this.getAttribute("id") === "next" ) {

    if (currentSlide === (slides.length - 1) ) {
      document.getElementById("next").style.opacity = 0.6;
      slide = slide + 1;
      nextSlide = slide;
      showSlides(nextSlide, currentSlide);
    } else if (currentSlide === (slides.length) ) {

    } else {
      document.getElementById("prev").style.opacity = 1;
      slide = slide + 1;
      nextSlide = slide;
      showSlides(nextSlide, currentSlide);

    }

  } else {
    console.log(currentSlide);
    if (currentSlide === 2 ) {
      console.log("hi");
      // map.closePopup();
      document.getElementById("prev").style.opacity = 0.6;
      slide = slide - 1;
      nextSlide = slide;
      showSlides(nextSlide, currentSlide);

    } else if ( currentSlide === 1 ) {

    } else {
      document.getElementById("next").style.opacity = 1;
      slide = slide - 1;
      nextSlide = slide;
      showSlides(nextSlide, currentSlide);
    }

  }


}

var showSlides = function(showSlide, hideSlide) {

  // console.log(showSlide + " " + hideSlide);
  var hide = document.querySelectorAll(`[data-num='${hideSlide}']`);
  var selectedHide = hide[0];
  var show = document.querySelectorAll(`[data-num='${showSlide}']`);
  var selectedShow = show[0];

  if (showSlide === 0){
    map.fitBounds(markergroup.getBounds());
  } else {
    var element = document.getElementById(showSlide);
    // var findMarker = document.querySelectorAll(`.ID${showSlide}`);
    // var centerMarker = findMarker[0];
    // centerMarker.click();
  }



  selectedShow.classList.add('is-visible');
  selectedHide.classList.remove('is-visible');
}


var slides = document.querySelectorAll(".slide");
// var dots = document.querySelectorAll(".distanceDot");
// console.log(slides.length);
// var last = slides[slides.length - 1];
var buttons = document.getElementsByClassName("moveButton");
var dots = document.getElementsByClassName("distanceDot");



function clickSlides() {
  var str = this.dataset.id;
  var res = str.split("ID");
  var number = res[1];
  document.querySelectorAll('.distanceDot').forEach(el => el.classList.remove('picked'));
  document.querySelectorAll('.line').forEach(el => el.classList.remove('is-visible'));

  this.classList.add('picked');

  slides.forEach(function(el) {
    el.classList.remove('is-visible');
  })

  var show = document.querySelectorAll(`[data-num='${number}']`);

  var selectedShow = show[0];

  var selectedHed = selectedShow.querySelector('.body-hed').innerHTML;
  console.log(selectedHed);

  document.querySelector('.map-container .body-hed').innerHTML = selectedHed;

  selectedShow.classList.add('is-visible');

  document.querySelector(`.Line${str}`).classList.add('is-visible');

  document.querySelectorAll(".Cat200").forEach(el => el.classList.remove("picked"));

  findMarker = document.querySelectorAll(`.ID${number}`);
  centerMarker = findMarker[0];
  centerMarker.classList.add("picked");
  centerMarker.click();

};

document.querySelectorAll(".Cat200").forEach(el => el.addEventListener('click', () => {
  document.querySelectorAll('.distanceDot').forEach(el => el.classList.remove('picked'));
  document.querySelectorAll('.Cat200').forEach(el => el.classList.remove('picked'));
  document.querySelectorAll('.line').forEach(el => el.classList.remove('is-visible'));

  document.querySelectorAll('.slide').forEach(el => el.classList.remove('is-visible'));



  var dotID = el.classList[2];
  var resid = dotID.split("ID");
  var numberid = resid[1];

  var show2 = document.querySelectorAll(`[data-num='${numberid}']`);
  var selectedShow2 = show2[0];
  selectedShow2.classList.add('is-visible');

  var selectedHed2 = selectedShow2.querySelector('.body-hed').innerHTML;
  document.querySelector('.map-container .body-hed').innerHTML = selectedHed2;
  console.log(selectedHed2);

  document.querySelector(`.Line${dotID}`).classList.add('is-visible');
  document.querySelector(`.D${dotID}.distanceDot`).classList.add('picked');

  el.classList.add("picked");
  // centerMarkerFirst.click();
}));

var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var distanceBar = ((w > 480) ? document.querySelector("#distanceBarDesktop") : document.querySelector("#distanceBarMobile"));


window.course.forEach(function(data) {

  var percentage = (data.distance / maxTrip) * 100;
  var div = document.createElement("div");
  div.className = "D" + data.id  + " distanceDot";

  if (w > 480){
    div.style.left = percentage + "%";
  } else {
    div.style.top = percentage + "%";
  }

  div.dataset.id = data.id;
  div.addEventListener("click", clickSlides);
  distanceBar.appendChild(div);
});



var first = document.getElementById("ID1");
first.classList.add('is-visible');
var findMarkerFirst = document.querySelectorAll(`.ID1`);
var centerMarkerFirst = findMarkerFirst[0];

centerMarkerFirst.classList.add("picked");
centerMarkerFirst.click();

document.querySelector('[data-id="ID1"]').classList.add('picked');
